module.exports = __webpack_public_path__ + "static/img/marquee.f4b2a948.png";